import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { ChangeDetectorRef, Component, Input, inject } from "@angular/core";

@Component({
  template: "",
  standalone: false,
})
export abstract class XyzLayerComponent {
  protected readonly cdr = inject(ChangeDetectorRef);

  layers: any[] = [];

  tilesMatrixSet: any[] = [];

  matrixConfiguration: any;

  hide = true;

  isLoading = false;

  urlType: string;

  isAuthRequired: boolean;

  @Input()
  url = "";

  form = new FormGroup({
    username: new FormControl(""),
    password: new FormControl(""),
  });

  newLayerForm = new FormGroup({
    selectedLayer: new FormControl(undefined),
    newWMTSLayerOpacity: new FormControl(75),
  });

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected geoJSONDatabaseService: GeoJSONDatabaseService,
    protected matDialog: MatDialog,
  ) {}

  onAuthRequireChange(event: any) {
    this.isAuthRequired = event.value;
    document.getElementById("lblError").innerHTML = "";
  }

  fieldsCompleted() {
    return this.isAuthRequired && this.form.get("username").value !== "" && this.form.get("password").value !== "";
  }

  usernameExists() {
    return this.form.get("username").value.length > 0;
  }

  passwordExists() {
    return this.form.get("password").value.length > 0;
  }

  abstract loadLayers();
}
